import { SPECIALISTS, specialistId } from "./specialists";

const CSS = ".vfrc-system-response .vfrc-avatar{object-fit:cover;object-position:center center;border-radius:9999px;overflow:hidden}"
  + ".gf-save-answer{margin:2px 0 10px 52px;display:inline-flex;align-items:center;gap:6px;border:1px solid #A7C4B5;background:#fff;color:#14532D;"
  + "font:600 12px/1 system-ui,sans-serif;padding:7px 12px;border-radius:999px;cursor:pointer}.gf-save-answer:hover{background:#F3F8F5}";
const MIN_CARD_TEXT = 180;
const MSG = ".vfrc-system-response, .vfrc-user-response";

const readMessages = (root, log) => {
  let agent = -1;
  return [...root.querySelectorAll(MSG)]
    .filter((el) => !el.parentElement?.closest(MSG))
    .map((el) => {
      const isAgent = el.matches(".vfrc-system-response");
      if (isAgent) agent += 1;
      const links = [...el.querySelectorAll("a[href^='http']")].slice(0, 30)
        .map((a) => ({ title: (a.innerText || "").trim().slice(0, 400), url: a.href.slice(0, 1200) }));
      return { role: isAgent ? "agent" : "user", speaker: isAgent ? log[agent] || "verdant" : null,
        text: (el.innerText || "").trim().slice(0, 20000), links };
    })
    .filter((m) => m.text);
};

// Each agent reply keeps the specialist who was active when it first appeared; scrolling never changes it.
export function attachResponseAvatars(host, caseId, onMessages, onSaveAnswer) {
  const speakerKey = `gf.verdant.speaker.${caseId}`;
  const logKey = `gf.verdant.replies.${caseId}`;
  let log = [];
  try { log = JSON.parse(sessionStorage.getItem(logKey)) || []; } catch { log = []; }
  let observer = null;
  let timer = null;
  let last = "";

  const apply = (root) => {
    root.querySelectorAll(".vfrc-system-response").forEach((reply, i) => {
      if (!log[i]) {
        log[i] = specialistId(sessionStorage.getItem(speakerKey));
        sessionStorage.setItem(logKey, JSON.stringify(log));
      }
      const src = SPECIALISTS[log[i]].face;
      reply.querySelectorAll("img.vfrc-avatar").forEach((img) => {
        if (!img.src.endsWith(src)) img.src = src;
        img.alt = SPECIALISTS[log[i]].name;
      });
      const next = reply.nextElementSibling;
      if (onSaveAnswer && i > 0 && !next?.classList?.contains("gf-save-answer") && (reply.innerText || "").trim().length >= MIN_CARD_TEXT) {
        const b = document.createElement("button");
        b.className = "gf-save-answer";
        b.type = "button";
        b.setAttribute("data-testid", `save-answer-${i}`);
        b.textContent = "\u2B07 Save or share this answer";
        b.onclick = () => onSaveAnswer({ speaker: log[i], text: (reply.innerText || "").trim(), request_id: `${caseId}-${i}-${Date.now()}` });
        reply.after(b);
      }
    });
    if (onMessages) {
      const msgs = readMessages(root, log);
      const sig = JSON.stringify(msgs);
      if (sig !== last) { last = sig; onMessages(msgs); }
    }
  };

  const start = () => {
    const root = host.shadowRoot;
    if (!root) { timer = setTimeout(start, 200); return; }
    const style = document.createElement("style");
    style.textContent = CSS;
    root.appendChild(style);
    apply(root);
    observer = new MutationObserver(() => apply(root));
    observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["src"] });
  };
  start();

  return () => { clearTimeout(timer); observer?.disconnect(); };
}
